import {DayColumn} from './DayColumn.tsx'
import dayjs, {type Dayjs} from 'dayjs'
import {Paper, useComputedColorScheme} from '@mantine/core'
import {useDayItems} from '../../providers/dayItems/useDayItems.ts'
import {useLocalSettings} from '../../providers/localSettings/useLocalSettings.ts'
import {useFilters} from './providers/filters/useFilters.ts'
import {useSubscription} from '../../providers/subscription/useSubscription.ts'

type Props = {
  days: Dayjs[]
  disabled: boolean
}

export const WeekContainer = ({days, disabled: containerDisabled}: Props) => {
  const {activeSubscriptionTier} = useSubscription()
  const {projectId} = useFilters()
  const {showRecommendations, mergeRecommendations} = useLocalSettings()
  const {
    dayItems,
    dayItemsWithMerged,
    loading: loadingTimeEntries,
    acceptRecommendation,
    rejectRecommendation,
  } = useDayItems()
  const colorScheme = useComputedColorScheme()

  const loading = loadingTimeEntries
  const disabled = loading || containerDisabled || activeSubscriptionTier.tier === 'none'

  const currentDayItems = mergeRecommendations ? dayItemsWithMerged : dayItems

  return (
    <div
      style={{
        display: 'flex',
        gap: 5,
        overflow: 'scroll',
        margin: -15,
        padding: 15,
        minHeight: 400,
      }}
    >
      {days.map((day) => {
        const dayStart = day.startOf('day')
        const dayEnd = day.endOf('day')
        const isDay = (date: Dayjs) => date.isSame(dayStart) || (date.isAfter(dayStart) && date.isBefore(dayEnd))
        const isToday = dayjs().startOf('day').isSame(dayStart)

        return (
          <Paper
            p={5}
            key={day.unix()}
            style={{
              flex: 1,
              minWidth: 225,
            }}
            bg={
              isToday
                ? colorScheme === 'dark'
                  ? 'var(--mantine-color-dark-6)'
                  : 'var(--mantine-color-gray-4)'
                : colorScheme === 'dark'
                  ? 'var(--mantine-color-dark-8)'
                  : 'var(--mantine-color-gray-2)'
            }
          >
            <DayColumn
              day={{start: day.startOf('day'), end: day.endOf('day')}}
              dayItems={currentDayItems.filter(({item, type}) => {
                if (!showRecommendations && type === 'recommendation') return false
                if (!showRecommendations && type === 'merged-recommendation') return false
                if (!!projectId && item.projectId !== projectId) return false
                return isDay(dayjs(item.start))
              })}
              onAcceptRecommendation={acceptRecommendation}
              onRejectRecommendation={rejectRecommendation}
              loading={loading}
              disabled={disabled}
            />
          </Paper>
        )
      })}
    </div>
  )
}
